import React from 'react'

function Footer() {
    return (
        // <h1>Footer</h1>
        <>
        <footer className="bg-gray-800 text-white text-center p-4 mt-auto">
        <p>© Some rights are reserved | BPL-2025</p>
      </footer>
        </>
    )
}

export default Footer
